import type { ComponentPropsWithRef, ReactNode } from "react";
import { cn } from "@/lib/utils";
import { type FieldSize, fieldChrome, inlineFieldChrome } from "./field-chrome";

interface Chrome {
  size?: FieldSize;
  /** Boxed for a form; inline for a line drawn as itself until it is written in. */
  appearance?: "boxed" | "inline";
  children?: ReactNode;
}

export type InputProps = Chrome &
  Omit<ComponentPropsWithRef<"input">, keyof Chrome>;

/** The field an attorney types one line into. */
export function Input({
  size,
  appearance = "boxed",
  className,
  ...rest
}: InputProps) {
  return (
    <input
      className={cn(
        appearance === "inline" ? inlineFieldChrome() : fieldChrome(size),
        className,
      )}
      {...rest}
    />
  );
}
